var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg27E06Fbd92F13D40Bb41991Bcd741A47(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.893,
    height: 23.616,
    viewBox: "0 0 18.893 23.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_27e06fbd92f13d40bb41991bcd741a47",
    "data-name": "27e06fbd92f13d40bb41991bcd741a47",
    d: "M6.906,16a31.8,31.8,0,0,1,5.108,0,20.831,20.831,0,0,1,2.758.347c1.972.4,3.259,1.051,3.81,2.1a2.908,2.908,0,0,1,0,2.616c-.552,1.051-1.788,1.744-3.831,2.1a19.8,19.8,0,0,1-2.758.357,23.514,23.514,0,0,1-2.584.095H7.846a7.45,7.45,0,0,0-.95-.063,18.879,18.879,0,0,1-2.758-.347c-1.972-.378-3.259-1.051-3.81-2.1A2.881,2.881,0,0,1,0,19.781a2.849,2.849,0,0,1,.317-1.334c.541-1.051,1.829-1.733,3.821-2.1A20.173,20.173,0,0,1,6.906,16ZM9.449,0a6.291,6.291,0,0,1,6.2,6.377,6.291,6.291,0,0,1-6.2,6.377,6.291,6.291,0,0,1-6.2-6.377A6.291,6.291,0,0,1,9.449,0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg27E06Fbd92F13D40Bb41991Bcd741A47);
export default __webpack_public_path__ + "static/media/27e06fbd92f13d40bb41991bcd741a47.39b5d7f33ed77535e509237c9c253f69.svg";
export { ForwardRef as ReactComponent };